<script>
	// NPM Modules
	import { navigate } from 'svelte-navaid';
	// Stores
	import SportStore from '@/Stores/Sport/SportStore';
	// Components
	import Modal from '@/Components/Modal.svelte';
	import TextInput from '@/Components/TextInput.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import SelectInput from '@/Components/SelectInput.svelte';
	import FontIcon from '@/Components/FontIcon.svelte';
	import Switch from '@/Components/Switch.svelte';
	// Services
	import { notify } from '@/Services/Notify';
	// Constants
	import { SportIcons } from '@/Constants/Icons';

	export let open;

	let sending = false;

	let sportForm = {
		name: '',
		icon: null,
		cashout_enabled: false
	};

	$: availableIcons = doIconMap();

	function doIconMap() {
		let iconArray = [];
		for (const iconName in SportIcons) {
			iconArray.push({ name: iconName, code: SportIcons[iconName] });
		}
		return iconArray;
	}

	function createManualSport() {
		sending = true;
		SportStore.createSport(sportForm.name, sportForm.icon, sportForm.cashout_enabled)
			.then((sport) => {
				notify({
					type: 'success',
					title: 'Manual sport created',
					message: 'Manual sport successfully created!',
					timeout: 3
				});
				navigate(`/sport/manage/${sport.id}`);
				open = false;
				sportForm.name = '';
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Error!',
					message: (e.error && e.error[0]) || 'Problem creating new manual sport',
					timeout: 5
				});
			})
			.finally(() => (sending = false));
	}
</script>

{#if open}
	<Modal on:close={() => (open = false)}>
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">Create a new manual sport</h2>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			<TextInput
				name="sportName"
				className="py-4 w-full"
				placeholder="Enter new sport name"
				bind:value={sportForm.name}
			/>
			<div class="flex flex-row text-left mb-6">
				<SelectInput label="Icon" name="Icon" className="w-3/4" bind:value={sportForm.icon}>
					<option value={undefined}>Select Icon...</option>
					<option value={null}>No icon</option>
					{#each availableIcons as icon (icon.name)}
						{#if icon.name === sportForm.icon || icon.code === sportForm.icon}
							<option value={icon.code} selected>{icon.name}</option>
						{:else}
							<option value={icon.code}>{icon.name}</option>
						{/if}
					{/each}
				</SelectInput>
				<div class="w-1/4 text-center justify-center">
					{#if sportForm.icon}
						<div>
							{#key sportForm.icon}
								<FontIcon icon={sportForm.icon} className=" icon text-6xl" />
							{/key}
						</div>
					{/if}
				</div>
			</div>
			<div class="flex flex-row mb-2">
				<label class="form-label" for="sportCashoutEnabled"
					>Cashout enabled:
					<Switch name="sportCashoutEnabled" bind:checked={sportForm.cashout_enabled} className="ml-1" />
				</label>
			</div>
			<LoadingButton on:click={() => createManualSport()} loading={sending} className="mb-4 btn btn-primary mt-4">
				Create
			</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click={() => (open = false)}>Cancel</button>
		</div>
	</Modal>
{/if}
